import { useEffect, useState } from 'react';

const TYPE_MS = 70;
const DELETE_MS = 35;
const HOLD_TYPED_MS = 1400;
const HOLD_EMPTY_MS = 350;

// Types each phrase, holds it, deletes it, then moves on to the next,
// looping back to the first. Returns the text currently "typed".
// Resets to an empty string whenever it is inactive.
export default function useTypewriter(phrases, active) {
  const [text, setText] = useState('');

  useEffect(() => {
    if (!active || !phrases.length) {
      setText('');
      return undefined;
    }

    let phraseIndex = 0;
    let length = 0;
    let deleting = false;
    let timer;

    const step = () => {
      const phrase = phrases[phraseIndex];
      let delay;

      if (!deleting) {
        length += 1;
        if (length >= phrase.length) {
          deleting = true;
          delay = HOLD_TYPED_MS;
        } else {
          delay = TYPE_MS;
        }
      } else {
        length -= 1;
        if (length <= 0) {
          deleting = false;
          phraseIndex = (phraseIndex + 1) % phrases.length;
          delay = HOLD_EMPTY_MS;
        } else {
          delay = DELETE_MS;
        }
      }

      setText(phrase.slice(0, length));
      timer = setTimeout(step, delay);
    };

    timer = setTimeout(step, TYPE_MS);
    return () => clearTimeout(timer);
  }, [active, phrases]);

  return text;
}
